import Vue from "vue";
import Component from "vue-class-component";
import { securityService } from '@/services/securityService';
import { usersStore } from "@/modules/Utenti/store/users.store";
import { Async } from '@/utils/AsyncDecorators';
import { toastHelper } from '@/helpers/ToastHelper';
import { PersistentStore } from '@/utils/PersistentStore';

@Component({ components: {} })
export default class ChangeUserData extends Vue {

  @Async({ async get() { return await usersStore.getters.get(securityService.getInfo().sub); }, default: [], lazy: false })
  current: server.user;

  async save() {
    usersStore.actions.setUtenti(this.current).then(async () => {
      let r: server.userInfo = await PersistentStore.getKey("userInfo");
      r.firstName = this.current.firstName;
      r.lastName = this.current.lastName;
      securityService.setUserInfo(r as server.userInfo);

      toastHelper.success("I dati sono stati modificati con successo!");
    }, (() => {
      toastHelper.error("Si è verificato un errore nella modifica dei dati dell'account.");
    }));
  }
}